import { Router ,CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Injectable } from '@angular/core';
import { AuthService } from './auth.service';

@Injectable()
export class GuestGuard implements CanActivate {

  constructor(private authService: AuthService,  public router: Router) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
   if(this.authService.isAuthenticated()){
        this.router.navigate(['dashboard']);
        return false;
    }
    return true;
  }
}
